import { EVENT_TYPE_LABELS_PT } from "@/features/tracking/constants/events";
import type { EventTypeCode } from "@/features/tracking/types/events";
import type {
	EventsMetrics,
	EventsMetricsChartRow,
} from "../types/events-metrics";

export function buildEventsMetricsChartRows(
	metrics: EventsMetrics | undefined
): EventsMetricsChartRow[] {
	if (!metrics?.items) {
		return [];
	}
	return (Object.entries(metrics.items) as [string, number][])
		.map(([key, count]) => {
			const code = Number(key) as EventTypeCode;
			return {
				name: EVENT_TYPE_LABELS_PT[code] ?? `Tipo ${key}`,
				count,
			};
		})
		.filter((row) => row.count > 0)
		.sort((a, b) => b.count - a.count);
}

export function buildHorizontalBarXAxisTicks(maxCount: number): {
	domain: [number, number];
	ticks: number[];
} {
	if (maxCount <= 0) {
		return { domain: [0, 80], ticks: [0, 20, 40, 60, 80] };
	}
	const padded = maxCount * 1.12;
	let step = 20;
	if (padded > 200) {
		step = Math.max(40, Math.ceil(padded / 5 / 20) * 20);
	} else if (padded > 120) {
		step = 40;
	}
	const ceilMax = Math.max(80, Math.ceil(padded / step) * step);
	const ticks: number[] = [];
	for (let t = 0; t <= ceilMax; t += step) {
		ticks.push(t);
	}
	return { domain: [0, ceilMax], ticks };
}
